import * as types from './mutation_types'

const ACCOUNT_SERVICE_URL = '/accountservice'  // due to cors
const AGV_REQUEST_URL = '/agvrequest'
const AGV_FLOW_URL = '/agvflow'
const PUSH_DEVICE_URL = '/pushdevice'
const PUSH_MESSAGE_URL = '/pushmessage/'

export default {
    async actGetTasks({commit}, flowuuid) {
        await fetch(AGV_FLOW_URL+'?tasks='+flowuuid)
        .then(function(response) {
            if (response.ok) {
                return response.json()
            } else {
                console.error('fetch(AGV_SERVICE/tasks) err: ', response)
            }
        })
        .then(function(data) {
            commit(types.GET_TASKS, data)
        })
        .catch(function(error) {
            console.error('catch(AGV_SERVICE/tasks) err: ', error)
        })
    },

    async actGetFlow({commit}, initiator) {
        await fetch(AGV_FLOW_URL+'?initiator='+initiator)
        .then(function(response) {
            if (response.ok) {
                return response.json()
            } else {
                console.error('fetch(AGV_SERVICE/flow) err: ', response)
            }
        })
        .then(function(data) {
            if (data.Status != 404) {
                commit(types.GET_FLOW, data)
            }
        })
        .catch(function(error) {
            console.error('catch(AGV_SERVICE/flow) err: ', error)
        })
    },

    async actCancelFlow({commit}, flowuuid) {
        //console.log('cancel: ', AGV_FLOW_URL+'/'+flowuuid+'/cmd?action=cancel')
        await fetch(AGV_FLOW_URL+'/'+flowuuid+'/cmd?action=cancel', {
            method: 'PUT'
        })
        .then(function(response) {
            if (response.ok) {
                return response.json()
            } else {
                console.error('cancel(AGV_SERVICE/flow) err: ', response)
            }
        })
        .then(function(data) {
            commit(types.GET_TASKS, data)
        })
        .catch(function(error) {
            console.error('catch(AGV_SERVICE/flow) err: ', error)
        })
    },

    async actSubmitRequest({commit}, jobj) {
        await fetch(AGV_REQUEST_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(jobj)
        })
        .then(function(response) {
            if (response.ok) {
                return response.json()
            } else {
                console.error('fetch(AGV_SERVICE_URL/request err: ', response)
            }
        })
        .then(function(data) {
            commit(types.SUBMIT_REQUEST, data)
        })
        .catch(function(error) {
            console.error('catch(AGV_SERVICE_URL/request) err: ', error)
        })
    },

    actSaveFavorite({commit}, favo) {
        commit(types.SAVE_FAVORITE, favo)
    },
    actDeleteFavorite({commit}, obj) {
        console.log('actions::actDeleteFavorite: obj', obj)
        commit(types.DELETE_FAVORITE, obj)
    },

    actGetUserList({commit}) {
        fetch(ACCOUNT_SERVICE_URL)
        .then(function(response) {
            if (response.ok) {
                return response.json()
            } else {
                console.error('fetch(ACCOUNTSERVICE) err: ', response)
            }
        })
        .then(function(data) {
            commit(types.GET_USERLIST, data)
        })
        .catch(function(error) {
            console.error('catch(ACCOUNTSERVICE) err: ', error)
        })
    },

    pushRegisterDevice({commit}, jobj) {
        fetch(PUSH_DEVICE_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(jobj)
        })
        .then(function(response) {
            if (response.ok) {
                return response.json()
            } else {
                console.error('fetch(PUSH_DEVICE_URL err: ', response)
            }
        })
        .then(function(data) {
            commit(types.PUSH_REGISTER_DEVICE, data)
        })
        .catch(function(error) {
            console.error('catch(PUSH_DEVICE_URL) err: ', error)
        })
    },
    async actGetMessages({commit}, identity) {
        await fetch(PUSH_MESSAGE_URL+identity)
        .then(function(response) {
            if (response.ok) {
                return response.json()
            } else {
                console.error('fetch(PUSH_MESSAGE_URL) err: ', response)
            }
        })
        .then(function(data) {
            if (data.Status != 404) {
                commit(types.PUSH_GET_MESSAGE, data)
            }
        })
        .catch(function(error) {
            console.error('catch(PUSH_MESSAGE_URL) err: ', error)
        })
    },
    actDeleteMessage({commit}, idx) {
        //console.log('actions::actDeleteMessage: idx', idx)
        commit(types.PUSH_DELETE_MESSAGE, idx)
    },

    actSaveUserInfo({commit}, info) {
        console.log('info: ', JSON.stringify(info))
        commit(types.SAVE_USER_INFO, info)
    },

    login({commit}, {account, pwd}) {
        console.log('login: ', account)
    },
    setLocale({commit}, locale) {
        commit(types.SET_LOCALE, locale)
    }
}



// WEBPACK FOOTER //
// ./src/store/actions.js